module.exports = __webpack_public_path__ + "static/media/flutter.28a94886.svg";